import { useTheme } from '@mui/material';
import type { Theme } from '@mui/material';
import type { AppPalette } from 'theme/types';

/**
 * Theme z rozszerzonym palette.app (kolory z theme/_color.scss).
 * Użyj zamiast useTheme(), gdy potrzebujesz theme.palette.app.*
 */
export type ThemeWithApp = Theme & {
  palette: Theme['palette'] & { app: AppPalette };
};

export function useAppTheme(): ThemeWithApp {
  return useTheme() as ThemeWithApp;
}
